<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/controlled-input.html" name="c-controlled-input">
<link rel="ractive" href="../components/results-raw-output.html" name="c-gp-results-raw-output">
<link rel="ractive" href="../components/jumbotron.html" name="c-gp-jumbotron">
<link rel="ractive" href="../components/test-depiction.html" name="c-gp-test-depiction">
<link rel="ractive" href="../components/placeholder-skeleton.html" name="c-placeholder-skeleton">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>

	<c-gp-header additionalClasses="header-with-globalping-bg"></c-gp-header>

	<div class="p-globalping-network-tools">
		<div class="gp-nettools_main-info">
			<c-gp-jumbotron className="network-tools" gridType="type2"></c-gp-jumbotron>

			<div class="gp-nettools_main-info_content">
				{{#if locationData}}
					<h1>{{displayingTestType}} from {{#if locationData.probesCnt}}multiple locations in {{/if}}</h1>
					<span class="gp-nettools_main-info_content_location">
						{{#if locationData.name}}
							<span>{{locationData.name}}</span>
						{{/if}}

						{{#unless locationData.type === 'asn' || locationData.type === 'isp' || locationData.type === 'cloudRegion'}}
							{{#if locationData.name}}
								<span>,&nbsp;</span>
							{{/if}}

							<a target="_blank" rel="noopener noreferrer" href="{{highLevelLocationHref}}" class="gp-nettools_green-text">
								{{locationData.from}}
							</a>
						{{/unless}}
					</span>

					{{#if locationData.type === 'asn'}}
						<a href="/networks/{{locationData.fromAsUrlPart}}" class="gp-nettools_network-link">
							{{locationData.from}}
						</a>
					{{/if}}

					<div class="gp-nettools_main-info_content_input-block">
						<span>Run a Free</span>

						<div class="gp_dropdown_alt">
							<div class="btn-group">
								<button type="button"
									class="dropdown-toggle"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false">
									<span>{{~/displayingTestType}}</span>
									<i class="fa fa-angle-down" aria-hidden="true"></i>
								</button>

								<ul role="listbox" class="dropdown-menu">
									{{#each ~/testTypesList}}
										{{#if this.toDisplay !== displayingTestType}}
											<li aria-selected="false"
												role="option"
												on-click="@this.handleTestTypeSelect(this.name)">
												{{this.toDisplay}}
											</li>
										{{/if}}
									{{/each}}
								</ul>
							</div>
						</div>

						<span>test</span>
					</div>
				{{elseif rawLocationToDisplay}}
					<h1>{{displayingTestType}} from multiple locations in </h1>
					<span class="gp-nettools_main-info_content_temp-location">
						{{#if rawLocationToDisplay.toLowerCase() !== 'world'}}
							{{rawLocationToDisplay}},
						{{/if}}

						<a target="_blank" rel="noopener noreferrer" href="{{global.location.origin}}/network-tools/{{selectedTestType}}-from-world" class="gp-nettools_green-text">
							World
						</a>
					</span>

					<div class="gp-nettools_main-info_content_input-block">
						<span>Run a Free</span>

						<div class="gp_dropdown_alt">
							<div class="btn-group">
								<button type="button"
									class="dropdown-toggle"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false">
									<span>{{~/displayingTestType}}</span>
									<i class="fa fa-angle-down" aria-hidden="true"></i>
								</button>

								<ul role="listbox" class="dropdown-menu">
									{{#each ~/testTypesList}}
										{{#if this.toDisplay !== displayingTestType}}
											<li aria-selected="false"
												role="option"
												on-click="@this.handleTestTypeSelect(this.name)">
												{{this.toDisplay}}
											</li>
										{{/if}}
									{{/each}}
								</ul>
							</div>
						</div>

						<span>test</span>
					</div>
				{{/if}}
			</div>
		</div>

		<div class="gp-nettools_demo-tools">
			<div class="gp-nettools_demo-tools_head">
				<span></span>
				<span></span>
				<span></span>
			</div>

			<div class="gp-nettools_demo-tools_ctrls">
				<c-controlled-input
					id="targetInput"
					value="{{testOpts.target}}"
					error="{{inputErrors.target}}"
					placeholder="IP or host"
					labelText="Target"
					classList="gp-nettools_demo-tools_ctrls_target gp_input">
				</c-controlled-input>

				<c-controlled-input
					id="limitInput"
					value="{{testOpts.limit}}"
					error="{{inputErrors.limit}}"
					placeholder="{{defaultTestLimit}}"
					labelText="Probes"
					classList="gp-nettools_demo-tools_ctrls_probes gp_input">
				</c-controlled-input>

				<button on-click="@this.proceedToTest()"
					class="gp-nettools_demo-tools_ctrls_btn gp_btn_green {{#if testInProgress}}gp_btn_green_disabled gp_btn_green_loading{{/if}}"
					data-testid="network-tools-run-test-btn"
					disabled="{{testInProgress}}">
					{{#if testInProgress}}
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					{{else}}
						Run {{btnTestType}} Test
					{{/if}}
				</button>
			</div>

			{{#if errorMessage}}
				<div class="gp-nettools_demo-tools_fail-msg">
					<img width="56"
						height="56"
						alt="Fail icon"
						src="{{@shared.assetsHost}}/img/fail-icon-big.svg">
					<p>
						{{{errorMessage}}}
					</p>
				</div>
			{{elseif testResults}}
				<div class="gp-nettools_demo-tools_raw-output">
					<c-gp-results-raw-output
						testReqParams="{{testReqParams}}"
						testInProgress="{{testInProgress}}"
						measurementsMetadata="{{measurementsMetadata}}"
						preparedTestResults="{{preparedTestResults}}"
						hiddenTestResults="{{hiddenTestResults}}"
						targetsCnt="{{1}}"
						showSetLocationButton="{{false}}"
						activeTargetIdx="{{0}}">
					</c-gp-results-raw-output>
				</div>
			{{else}}
				<div class="gp-nettools_demo-tools_descr">
					<img width="56"
						height="56"
						src="{{@shared.assetsHost}}/img/bulb-icon.svg">
						{{#if locationData}}
							<div class="gp-nettools_demo-tools_descr_text" data-testid="network-tools-description">
								Run a free global {{displayingTestType}} test! Benchmark and compare CDN and DNS providers to understand how their networks performs.
								Compare hosting and cloud providers to find the fastest one globally or in your region.
								Run {{displayingTestType}} tests from {{locationData.name || locationData.from}}, globally or from other locations or even cloud regions.
								Test, measure and troubleshoot your network for free using Globalping!
							</div>
						{{else}}
							<c-placeholder-skeleton type="descr"></c-placeholder-skeleton>
						{{/if}}
				</div>
			{{/if}}
		</div>

		<div class="gp-nettools_learn-how">
			{{#if locationData}}
				<span class="gp-nettools_learn-how_title">
					Explore how Globalping makes global network tests and benchmarking possible and free for all.
				</span>

				<span class="gp-nettools_learn-how_descr">
					Debug your web services and servers and understand and fix your routing by running network commands like ping from {{locationData.name || locationData.from}} or any other location like a country or city.
				</span>
			{{else}}
				<c-placeholder-skeleton type="header"></c-placeholder-skeleton>
				<c-placeholder-skeleton type="descr"></c-placeholder-skeleton>
			{{/if}}

			<a href="/" class="gp-nettools_learn-how_btn gp_btn_green">
				Learn more
			</a>
		</div>

		<c-gp-test-depiction locationData="{{locationData}}" selectedTestType="{{selectedTestType}}"></c-gp-test-depiction>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const dataCache = require('../../assets/js/utils/data-cache');
	const countries = require('../../assets/json/countries.json');
	const continents = require('../../assets/json/continents.json');
	const usaStates = require('../../assets/json/usa-states.json');
	const DEFAULT_LIMIT = 3;
	const INITIAL_OPTS_VALUES = {
		type: 'Ping',
		target: 'cdn.jsdelivr.net',
	};
	const CAPITALIZE_EXCLUDE_LIST = [ 'and', 'or', 'from', 'ltd', 'of' ];
	const RATE_LIMIT_HEADERS = [
		'x-ratelimit-remaining',
		'x-ratelimit-reset',
		'x-credits-remaining',
		'x-request-cost',
	];
	const PROBE_NO_TIMING_VALUE = _.getProbeTimeOutValue();
	const PROBE_STATUS_OFFLINE = _.getProbeStatusOfflineValue();

	component.exports = {
		data () {
			return {
				_,
				title: '',
				description: '',
				selectedTestType: null,
				displayingTestType: INITIAL_OPTS_VALUES.type,
				btnTestType: INITIAL_OPTS_VALUES.type,
				testTypesList: [
					{
						name: 'Ping',
						toDisplay: 'Ping',
					},
					{
						name: 'Traceroute',
						toDisplay: 'Traceroute',
					},
					{
						name: 'DNS',
						toDisplay: 'DNS resolve',
					},
					{
						name: 'MTR',
						toDisplay: 'MTR',
					},
					{
						name: 'HTTP',
						toDisplay: 'HTTP',
					},
				],
				testOpts: {
					target: INITIAL_OPTS_VALUES.target,
					limit: '',
				},
				inputErrors: {},
				errorMessage: null,
				testResults: null,
				testInProgress: false,
				testReqCancelFn: null,
				defaultTestLimit: DEFAULT_LIMIT,
				probesResponse: null,
				locationData: null,
				totalProbesCnt: 0,
				parsedLocations: {
					cities: {},
					asns: {},
					networks: {},
					countries: {},
					continents: {},
					regions: {},
					states: {},
					cloudRegions: {},
				},
				highLevelLocationHref: null,
				probesParsed: false,
				testReqParams: null,
				preparedTestResults: [],
				hiddenTestResults: { 0: [] },
				rawLocation: null,
				rawLocationToDisplay: null,
				allRequiredDataReady: false,
			};
		},
		onconfig () {
			if (!Ractive.isServer) {
				let title, description;
				let { rawTestType, rawLocation, rawLocationToDisplay } = this.getInitialRawDataFromUrl();

				// create temp title, descr before any checks, required by GA
				title = this.createMetaTitle(rawTestType, rawLocationToDisplay);
				description = this.createMetaDescr(rawTestType, rawLocationToDisplay);

				this.set('title', title);
				this.set('description', description);
				this.set('selectedTestType', rawTestType);
				this.set('rawLocation', rawLocation);
				this.set('rawLocationToDisplay', rawLocationToDisplay);
			}
		},
		oninit () {
			if (!Ractive.isServer) {
				this.getGlobalpingProbesData();

				this.observe('selectedTestType', (selectedTestType) => {
					if (selectedTestType) {
						switch (selectedTestType.toLowerCase()) {
							case 'mtr':
							case 'http':
								this.set('displayingTestType', selectedTestType.toUpperCase());
								this.set('btnTestType', selectedTestType.toUpperCase());

								break;

							case 'dns':
								this.set('displayingTestType', `${selectedTestType.toUpperCase()} resolve`);
								this.set('btnTestType', selectedTestType.toUpperCase());

								break;

							default:
								this.set('displayingTestType', _.capitalizeStrEveryFirstLetter(selectedTestType));
								this.set('btnTestType', _.capitalizeStrEveryFirstLetter(selectedTestType));
						}
					}

					this.set('inputErrors', {});
					this.set('testResults', null);
					this.expandAllRawOutput();
				});

				this.observe('realTimeTestResResponse', (realTimeTestResResponse) => {
					if (realTimeTestResResponse.status === 'finished') {
						this.get('testReqCancelFn')?.();
						this.set('testInProgress', false);
					}

					let prevTestResults = this.get('testResults') || [];
					let updTestResults = realTimeTestResResponse.results.map((res, resIdx) => ({
						...res,
						clientSideId: res.clientSideId ?? resIdx,
					}));

					// filter out results that have already been drawn
					prevTestResults = prevTestResults.filter((prevRes) => {
						return !updTestResults.some(updRes => updRes.clientSideId === prevRes.clientSideId);
					});

					this.set('testResults', [ ...prevTestResults, ...updTestResults ]);
				}, { init: false });

				// check if everything is already set and we can get LocationData etc.
				this.observe('probesParsed selectedTestType rawLocation', () => {
					let probesParsed = this.get('probesParsed');
					let selectedTestType = this.get('selectedTestType');
					let rawLocation = this.get('rawLocation');

					if (probesParsed && selectedTestType && rawLocation) {
						this.set('allRequiredDataReady', true);
					} else {
						this.set('allRequiredDataReady', false);
					}
				});

				// create and set meta title, description; locationData, highLevelLocationHref
				// check if location is correct or presented in the available probes locations
				this.observe('allRequiredDataReady', (allRequiredDataReady) => {
					if (allRequiredDataReady === false) { return; }

					let selectedTestType = this.get('selectedTestType');
					let rawLocation = this.get('rawLocation');

					// handle locationData, highLevelLocationHref
					if (rawLocation && rawLocation.toLowerCase() !== 'world') {
						let locationData = this.getLocDataByLocValue(rawLocation);

						if (locationData) {
							// if both location and testType are correct and present
							this.set('locationData', locationData);
							this.set('highLevelLocationHref', `${global.location.origin}${this.modifyQueryPart(selectedTestType, locationData.fromAsUrlPart)}`);
						} else {
							// when testType correct but location absent at the moment among the probes or incorrect
							this.moveToNewPageURL(selectedTestType);

							return;
						}
					} else {
						this.set('locationData', { from: 'World', probesCnt: this.get('totalProbesCnt') });
						this.set('highLevelLocationHref', `${global.location.origin}${this.modifyQueryPart(selectedTestType)}`);
					}

					// handle meta tag title and description once location is confirmed as presented
					let locationData = this.getLocDataByLocValue(rawLocation);
					let title = this.createMetaTitle(selectedTestType, locationData ? locationData.name : 'World');
					let description = this.createMetaDescr(selectedTestType, locationData ? locationData.name : 'world');

					this.set('title', title);
					this.set('description', description);
				});

				// set measurementsMetadata for the c-gp-results-share component
				this.observe('testReqParams', (testReqParams) => {
					if (!testReqParams) { return; }

					let measurementsMetadata = {
						0: {
							target: testReqParams.target,
							measurementId: testReqParams.id,
						},
					};

					this.set('measurementsMetadata', measurementsMetadata);
				});

				// prepare results for gp-results-raw-output
				this.observe('testResults', (testResults) => {
					if (!testResults) { return; }

					this.set('preparedTestResults', this.prepareRegularResults(testResults));
				});
			}
		},
		oncomplete () {
			if (!Ractive.isServer) {
				// run the test if user is pressed Enter inside of any of options inputs
				let targetInput = this.find('#targetInput');
				let limitInput = this.find('#limitInput');

				let handleEnterBtn = (event) => {
					if (event.key === 'Enter') {
						event.preventDefault();
						this.proceedToTest();
					}
				};

				targetInput.addEventListener('keypress', handleEnterBtn);
				limitInput.addEventListener('keypress', handleEnterBtn);
			}
		},
		onunrender () {
			this.get('testReqCancelFn')?.();
		},
		expandAllRawOutput () {
			this.set('hiddenTestResults', {
				0: [],
			});
		},
		proceedToTest () {
			let type = this.get('selectedTestType');
			let testOpts = this.get('testOpts');
			let { name: magic = 'World' } = this.get('locationData');
			let reqParams = {
				type,
				...testOpts,
				locations: [{ magic }],
			};

			if (!reqParams.limit) {
				reqParams.limit = DEFAULT_LIMIT;
			}

			// clear all data from the previous test, show spinner
			this.set('testResults', null);
			this.set('testInProgress', true);
			this.set('testReqParams', null);
			this.set('errorMessage', null);
			this.set('preparedTestResults', []);
			this.expandAllRawOutput();

			http.postGlobalpingMeasurement(reqParams, RATE_LIMIT_HEADERS).then((res) => {
				this.getTestMeasurementById(res.response.id);
			}).catch((err) => {
				let errBody = err?.error;
				this.set('testInProgress', false);

				if (errBody?.type === 'validation_error') {
					let inputErrors = _.parseValidationErrors(errBody);
					this.set('inputErrors', inputErrors);
				} else if (err.responseStatusCode === 429) {
					let measurementErrMsg = _.createMeasCreditsErrMsg(
						err.responseHeaders,
						this.get('@shared.user'),
					);

					this.set('errorMessage', measurementErrMsg);
				} else {
					this.set('errorMessage', err.error?.message ?? 'An unexpected error occurred.');
				}
			});
		},
		parseProbesResponse (data) {
			return data.reduce((res, { tags, location }) => {
				let cityNameLC = location.city.toLowerCase();
				let cityNameAsUrlPart = cityNameLC.split(' ').join('-');
				let countryCodeLC = location.country.toLowerCase();
				let country = countries.find(i => i.code.toLowerCase() === countryCodeLC);
				let countryNameLC = country.name.toLowerCase();
				let countryNameAsUrlPart = (country.nameAscii || country.name).toLowerCase().split(' ').join('-');
				let asnName = `as${location.asn}`;
				let networkNameAsKey = _.networkNameToKey(location.network);
				let continentCodeLC = location.continent.toLowerCase();
				let continentNameLC = continents.find(i => i.code.toLowerCase() === continentCodeLC).name.toLowerCase();
				let continentNameAsUrlPart = continentNameLC.split(' ').join('-');
				let regionNameLC = location.region.toLowerCase();
				let regionNameAsUrlPart = regionNameLC.split(' ').join('-');
				let stateCodeLC = location.state ? location.state.toLowerCase() : null;
				let stateNameLC = stateCodeLC ? usaStates.find(i => i.code.toLowerCase() === stateCodeLC).name.toLowerCase() : null;
				let stateNameAsUrlPart = stateNameLC ? stateNameLC.split(' ').join('-') : null;

				tags.forEach((tag) => {
					let tagLC = tag.toLowerCase();

					if (!_.isTagCloudRegion(tagLC)) {
						return;
					}

					if (!Object.keys(res.cloudRegions).includes(tagLC)) {
						res.cloudRegions[tagLC] = {
							name: tagLC,
							from: 'world',
							probesCnt: 1,
							fromAsUrlPart: tagLC,
						};
					} else {
						res.cloudRegions[tagLC].probesCnt += 1;
					}
				});

				// collect uniques cities and count amount of probes per city
				if (!Object.keys(res.cities).includes(cityNameAsUrlPart)) {
					res.cities[cityNameAsUrlPart] = {
						name: cityNameLC,
						from: countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase(),
						probesCnt: 1,
						fromAsUrlPart: countryNameAsUrlPart,
					};
				} else {
					res.cities[cityNameAsUrlPart].probesCnt += 1;
				}

				// collect uniques ASNs and count amount of probes per ASN
				if (!Object.keys(res.asns).includes(asnName)) {
					res.asns[asnName] = {
						name: asnName,
						from: location.network,
						probesCnt: 1,
						fromAsUrlPart: networkNameAsKey,
					};
				} else {
					res.asns[asnName].probesCnt += 1;
				}

				// collect uniques Networks and count amount of probes per Network
				if (!Object.keys(res.networks).includes(networkNameAsKey)) {
					res.networks[networkNameAsKey] = {
						name: location.network,
						from: 'world',
						probesCnt: 1,
						fromAsUrlPart: 'world',
					};
				} else {
					res.networks[networkNameAsKey].probesCnt += 1;
				}

				// collect uniques Countries and count amount of probes per Country
				if (!Object.keys(res.countries).includes(countryNameAsUrlPart)) {
					res.countries[countryNameAsUrlPart] = {
						name: countryNameLC,
						from: continentNameLC,
						probesCnt: 1,
						fromAsUrlPart: continentNameAsUrlPart,
					};
				} else {
					res.countries[countryNameAsUrlPart].probesCnt += 1;
				}

				// collect uniques Continents and count amount of probes per Continent
				if (!Object.keys(res.continents).includes(continentNameAsUrlPart)) {
					res.continents[continentNameAsUrlPart] = {
						name: continentNameLC,
						from: 'world',
						probesCnt: 1,
						fromAsUrlPart: 'world',
					};
				} else {
					res.continents[continentNameAsUrlPart].probesCnt += 1;
				}

				// collect uniques Regions and count amount of probes per Region
				if (!Object.keys(res.regions).includes(regionNameAsUrlPart)) {
					res.regions[regionNameAsUrlPart] = {
						name: regionNameLC,
						from: 'world',
						probesCnt: 1,
						fromAsUrlPart: 'world',
					};
				} else {
					res.regions[regionNameAsUrlPart].probesCnt += 1;
				}

				// collect uniques states (if they are present) and count amount of probes per state
				if (stateNameAsUrlPart) {
					if (!Object.keys(res.states).includes(stateNameAsUrlPart)) {
						res.states[stateNameAsUrlPart] = {
							name: stateNameLC,
							from: countries.find(i => i.code.toLowerCase() === countryCodeLC).name.toLowerCase(),
							probesCnt: 1,
							fromAsUrlPart: countryNameAsUrlPart,
						};
					} else {
						res.states[stateNameAsUrlPart].probesCnt += 1;
					}
				}

				return res;
			}, {
				cities: {},
				asns: {},
				networks: {},
				countries: {},
				continents: {},
				regions: {},
				states: {},
				cloudRegions: {},
			});
		},
		getLocDataByLocValue (location = '') {
			let locationLC = location.toLowerCase();
			let parsedLocations = this.get('parsedLocations');

			// check if the location is a city
			if (parsedLocations.cities[locationLC]) {
				let { name, from, probesCnt, fromAsUrlPart } = parsedLocations.cities[locationLC];

				return {
					name: _.capitalizeStrEveryFirstLetter(name),
					from: _.capitalizeStrEveryFirstLetter(from),
					probesCnt,
					fromAsUrlPart,
					type: 'city',
				};
			}

			// check if the location is an ASN
			if (parsedLocations.asns[locationLC]) {
				let { name, from, probesCnt, fromAsUrlPart } = parsedLocations.asns[locationLC];

				return {
					name: name.toUpperCase(),
					from,
					probesCnt,
					fromAsUrlPart,
					type: 'asn',
				};
			}

			// check if the location is a Network
			if (parsedLocations.networks[locationLC]) {
				let { name, from, probesCnt, fromAsUrlPart } = parsedLocations.networks[locationLC];

				return {
					name,
					from: _.capitalizeStrEveryFirstLetter(from),
					probesCnt,
					fromAsUrlPart,
					type: 'isp',
				};
			}

			// check if the location is a Country
			if (parsedLocations.countries[locationLC]) {
				let { name, from, probesCnt, fromAsUrlPart } = parsedLocations.countries[locationLC];

				return {
					name: _.capitalizeStrEveryFirstLetter(name),
					from: _.capitalizeStrEveryFirstLetter(from, CAPITALIZE_EXCLUDE_LIST),
					probesCnt,
					fromAsUrlPart,
					type: 'country',
				};
			}

			// check if the location is a Continent
			if (parsedLocations.continents[locationLC]) {
				let { name, from, probesCnt, fromAsUrlPart } = parsedLocations.continents[locationLC];

				return {
					name: _.capitalizeStrEveryFirstLetter(name),
					from: _.capitalizeStrEveryFirstLetter(from),
					probesCnt,
					fromAsUrlPart,
					type: 'continent',
				};
			}

			// check if the location is a Region
			if (parsedLocations.regions[locationLC]) {
				let { name, from, probesCnt, fromAsUrlPart } = parsedLocations.regions[locationLC];

				return {
					name: _.capitalizeStrEveryFirstLetter(name),
					from: _.capitalizeStrEveryFirstLetter(from),
					probesCnt,
					fromAsUrlPart,
					type: 'region',
				};
			}

			// check if the location is a State
			if (parsedLocations.states[locationLC]) {
				let { name, from, probesCnt, fromAsUrlPart } = parsedLocations.states[locationLC];

				return {
					name: _.capitalizeStrEveryFirstLetter(name),
					from: _.capitalizeStrEveryFirstLetter(from),
					probesCnt,
					fromAsUrlPart,
					type: 'state',
				};
			}

			if (parsedLocations.cloudRegions[locationLC]) {
				return { ...parsedLocations.cloudRegions[locationLC], type: 'cloudRegion' };
			}
		},
		getTestMeasurementById (measurementId) {
			let cancelled = false;
			let timeout = null;

			let cancel = () => {
				cancelled = true;
				clearTimeout(timeout);
				timeout = null;
			};

			let fetch = () => {
				if (cancelled) {
					return;
				}

				http.getGlobalpingMeasurement(measurementId).then((testRes) => {
					// prepare and set request params to pass them to gp-test-results
					let testReqParams = JSON.parse(JSON.stringify(testRes));

					delete testReqParams.results;
					delete testReqParams.status;
					delete testReqParams.updatedAt;
					delete testReqParams.createdAt;

					testReqParams = {
						inProgressUpdates: true,
						limit: DEFAULT_LIMIT,
						...testReqParams,
						measurementOptions: {
							trace: false,
							...testReqParams.measurementOptions,
						},
					};

					// set testReqParams to pass them to c-gp-results-raw-output
					this.set('testReqParams', testReqParams);

					// should be after the mainOptions.type was set
					this.set('realTimeTestResResponse', testRes);

					if (!cancelled) {
						timeout = setTimeout(fetch, 500);
					}
				}).catch(() => {
					cancel();
				});
			};

			fetch();
			this.set('testReqCancelFn', cancel);
		},
		handleTestTypeSelect (testTypeName) {
			this.set('selectedTestType', testTypeName);

			let newPath = this.modifyQueryPart(testTypeName);

			app.router.dispatch(newPath, { noScroll: true });
		},
		moveToNewPageURL (testType, newLocation = 'world') {
			let newPath = this.modifyQueryPart(testType, newLocation);

			window.location.replace(newPath);
		},
		modifyQueryPart (testType = 'ping', newLocation = null) {
			let newQueryTestFromValue = '';

			if (newLocation) {
				newQueryTestFromValue = `${testType}-from-${newLocation}`;
			} else {
				let splittedQueryTestFrom = app.router.uri.path.split('/');
				let currQueryTestFromValue = splittedQueryTestFrom[splittedQueryTestFrom.length - 1];

				newQueryTestFromValue = currQueryTestFromValue.replace(/[A-Za-z]+/, `${testType}`);
			}

			return `/network-tools/${newQueryTestFromValue.toLowerCase()}`;
		},
		getGlobalpingProbesData () {
			dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes)
				.then((response) => {
					this.set('parsedLocations', this.parseProbesResponse(response));
					this.set('totalProbesCnt', response.length);
					this.set('probesParsed', true);
				})
				.catch((error) => {
					console.error('Failed to fetch probes', error);
				});
		},
		checkIfTestTypeCorrect (testType) {
			if (!testType) { return false; }

			let testTypesList = this.get('testTypesList');

			return testTypesList.some(i => i.name.toLowerCase() === testType.toLowerCase());
		},
		createMetaTitle (testType, location) {
			switch (testType.toLowerCase()) {
				case 'dns':
				case 'mtr':
				case 'http':
					testType = testType.toUpperCase(); break;
				default:
					testType = _.capitalizeFirstLetter(testType);
			}

			return `${testType} for free from ${location} - Global ${testType} tests by Globalping`;
		},
		createMetaDescr (testType, location) {
			let description = `Run ${testType} network tests for free from multiple global regions`;

			if (location.toLowerCase() !== 'world') {
				description += ` like ${location}`;
			}

			description += ' to any endpoint including IP addresses, websites, CDN or cloud providers. Test the network latency and uptime regionally';

			if (location.toLowerCase() !== 'world') {
				description += ` in ${location}`;
			}

			description += ' or globally.';

			return description;
		},
		prepareRegularResults (testResults) {
			let dnsTraceEnabled = this.get('testReqParams.measurementOptions.trace');
			let selectedTestType = this.get('selectedTestType');

			return testResults.map((res, resIdx) => {
				let preparedRes = {
					...res.probe,
					clientSideId: res.clientSideId ?? resIdx,
					statsPerTarget: [{
						target: res.target,
						isInProgress: res.result.status === 'in-progress',
					}],
				};

				if (res.result.status !== 'in-progress') {
					let { isFailed = false, lastTiming, value: avgTiming, extraValues } = _.calcGpTestResTiming(selectedTestType, res, dnsTraceEnabled);
					let { packetsTotal } = _.parseGpRawOutputForTimings(res.result.rawOutput);
					let minTiming = res.result?.stats?.min || PROBE_NO_TIMING_VALUE;
					let maxTiming = res.result?.stats?.max || PROBE_NO_TIMING_VALUE;
					let isOffline = res.result.status === PROBE_STATUS_OFFLINE;

					preparedRes.statsPerTarget = [{
						...preparedRes.statsPerTarget[0],
						ipAddr: res.result.resolvedAddress,
						avgTiming,
						isFailed,
						isOffline,
						failureSource: res.result.failureSource,
						extraValues,
						rawOutput: res.result.rawOutput,
						areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal),
					}];
				}

				return preparedRes;
			});
		},
		checkAreTimingsReady (lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
			if (
				!packetsTotal
				|| typeof lastTiming === 'undefined'
				|| typeof maxTiming === 'undefined'
				|| typeof minTiming === 'undefined'
				|| typeof avgTiming === 'undefined'
			) {
				return false;
			}

			return true;
		},
		getInitialRawDataFromUrl () {
			let rawParamsValue = this.get('params');
			let clearParamsValue = rawParamsValue.replace(/\/network-tools\/?/, '').toLowerCase();
			let splitPoint = '-from-';
			let splitPointIdx = clearParamsValue.indexOf(splitPoint);
			let [ rawTestType, rawLocation = 'world' ] = splitPointIdx === -1
				? clearParamsValue.split(splitPoint)
				: [ clearParamsValue.slice(0, splitPointIdx), clearParamsValue.slice(splitPointIdx + splitPoint.length) ];
			let rawLocationToDisplay = _.capitalizeStrEveryFirstLetter((rawLocation || 'world').split('-').join(' '), CAPITALIZE_EXCLUDE_LIST);

			return {
				rawTestType,
				rawLocation,
				rawLocationToDisplay,
			};
		},
	};
</script>
